// this file is automatically generated by git.revision.js script
export const versions = { revision: 'ca8a4667f7' }; 
 //expose the commit hash to the window object 
//@ts-ignore 
window.rd_version = 'ca8a4667f7';
